import React, { FC, FormEvent, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from 'components/Dialog'
import { Icon } from 'components/Icon'
import { Heading } from 'components/Heading'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import styles from './PonderaRadio.module.scss'
import { Slider } from 'components/Slider'
//import { RadioGroup, RadioButton } from 'components/RadioButton'
import { AreaType } from 'models/project'
import { Flex } from 'components/Flex'
//import { useUserContext } from 'context/user-context'

type PonderaRadioProps = {
  onClose: () => void
  onConfirm: (data: any) => void
  status?: string
}

type Marks = {
  [key: string]: {
    [key: number]: {
      label: string
      value: number
    }
  }
}

export const PonderaRadio: FC<PonderaRadioProps> = ({
  onClose,
  onConfirm,
  status = 'idle',
}) => {
  const { t } = useTranslation()
  const [type, setType] = useState('')
  //const [time, setTime] = useState<string>(AreaType.ISOCHRONE_WALK)
  const [measure, setMeasure] = useState(1)
  //const [currentUser] = useUserContext()

  useEffect(() => setMeasure(1), [type])
  useEffect(() => setType("radius"), [type])

  const marks: Marks = {
    time: {
      1: { label: '5 min', value: 5 },
      2: { label: '10 min', value: 10 }
    },
    radius: {
      1: { label: '250m', value: 250 },
      2: { label: '500m', value: 500 }

    },
  }

  /* var radio = "";
   function valueRadio(event: any) {
     //const name = event.target.name;
     const value = event.target.value;
     radio = value;
   } */


  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {

    event.preventDefault()

    const isochrone = AreaType.RADIUS

    onConfirm({ areaType: isochrone, radius: marks["radius"][measure].value })

  }




  return (
    <Dialog
      aria-label={t('create_project.pondera_dialog.title')}
      isOpen={true}
      onClose={onClose}
      className={styles.isochroneDialog}
    >
      <Stack>
        <Stack space="xsmall" component="header">
          <Flex justify="start" align="center">
            <div className={styles.icon}>
              <Icon name="map-pin-line" />
            </div>
            <Heading size="secondary">{t('create_project.pondera_dialog.title')}</Heading>
          </Flex>
          <Text>{t('create_project.isochrone_dialog.desc')}</Text>
        </Stack>

        <form onSubmit={onFormSubmit}>
          <Stack space="medium">


            <Slider min={1} max={2} marks={marks["radius"]} onChange={setMeasure} value={measure} />


            <Button disabled={!type} type="submit" full loading={status === 'loading'}>
              {t('create_project.isochrone_dialog.cta')}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Dialog>
  )
}

PonderaRadio.displayName = 'PonderaRadio'
